import axios, { AxiosInstance } from "axios";

const publicApi: AxiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_URL || "https://dev-api.travelfirst.in/api/v1",
  timeout: Number(process.env.API_TIMEOUT) || 120000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default publicApi;
